import CornerstoneLogo from '@/assets/logos/CornerstoneLogo';
import { sanitizeContactUsHtml } from '@/utils/whiteLabeling/sanitizeContactUsHtml';
import useHubTranslation from '@/utils/i18n/useHubTranslation';
import {
  Box,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useMemo } from 'react';

const ContactUsModal = ({ isOpen, onClose, customHtml }) => {
  const { translateHubUi } = useHubTranslation();
  const sanitizedCustomHtml = useMemo(
    () => sanitizeContactUsHtml(customHtml),
    [customHtml]
  );
  const hasCustomContent = Boolean(sanitizedCustomHtml);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth='md'
      data-testid='contactUsModal'
    >
      {hasCustomContent ? (
        <>
          <DialogTitle>
            {translateHubUi('nav.contactUsModal.title', 'Contact Us')}
          </DialogTitle>
          <DialogContent>
            <Box
              data-testid='contactUsCustomHtml'
              sx={{
                color: 'text.primary',
                fontSize: '1rem',
                lineHeight: 1.5,
                '& h1, & h2, & h3, & h4, & h5, & h6, & p': {
                  marginBlock: 'revert',
                  fontSize: 'revert',
                  fontWeight: 'revert',
                  lineHeight: 'revert',
                  color: 'revert',
                  fontFamily: 'revert',
                  textAlign: 'revert',
                },
              }}
              dangerouslySetInnerHTML={{ __html: sanitizedCustomHtml }}
            />
          </DialogContent>
        </>
      ) : (
        <>
          <DialogTitle>
            <CornerstoneLogo />
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Typography>304 W. Kirkwood Ave.</Typography>
              <Typography>Suite 101</Typography>
              <Typography>Bloomington, IN 47404 USA</Typography>
              <Typography sx={{ mt: 2 }}>
                Toll Free: +1 (800) 276-8255
              </Typography>
              <Typography>USA/North America: +1 (812) 330-4361</Typography>
              <Typography sx={{ mt: 2 }}>
                {translateHubUi('nav.contactUsModal.salesLabel', 'Sales:')}{' '}
                <a href='mailto:ask@ciswired.com'>ask@ciswired.com</a>
              </Typography>
              <Typography>
                {translateHubUi('nav.contactUsModal.supportLabel', 'Support:')}{' '}
                <a href='mailto:support@ciswired.com'>support@ciswired.com</a>
              </Typography>
            </DialogContentText>
          </DialogContent>
        </>
      )}
    </Dialog>
  );
};

export default ContactUsModal;
